export function currentMethodName(num = 2) {
    try {
        throw new Error();
    } catch (e) {
        try {
            return (e as Error).stack?.split('at ')[num].split(' ')[0].split('.').pop();
        } catch (e) {
            return '';
        }
    }
}
